module.exports = __webpack_public_path__ + "img/400.4bed37f9.png";